import {defineStore} from "pinia";
import axios from "axios";
import moment from "moment";

export const BookingCalendarStore = defineStore('bookingCalendar', {
    state: () => ({
        times: {},
    }),
    actions: {
        getTimes ({location, date, sessionCategory}) {
            return new Promise(async (resolve, reject) => {
                const key = [location.id, date.toLocaleDateString("en-GB"), sessionCategory.id].join("_");

                if (typeof this.times[key] !== "undefined") {
                    resolve(this.times[key]);
                    return;
                }

                try {
                    const response = await axios.post('/wp-json/bookings/v1/booking-list/', {
                        location: location.id,
                        date: moment(date).format('YYYY-MM-DD'),
                        sessionCategory: sessionCategory.id,
                    });
                    this.times[key] = response.data;
                    resolve(response.data);
                } catch (error) {
                    reject(error);
                }
            })
        }
    }
});